// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-dark-background {
  --background: #090909;
}

.button-close {
  display: flex;
  justify-content: flex-end;
}

.app-webcontent-parent {
  overflow-y: auto;
}
.app-webcontent-parent ion-content::part(scroll) {
  overflow-y: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-webview/popover-dark-webview/popover-dark-webview.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;AACF;AAAE;EACE,kBAAA;AAEJ","sourcesContent":[".popover-dark-background {\n  --background: #090909;\n}\n\n.button-close {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.app-webcontent-parent {\n  overflow-y: auto;\n  ion-content::part(scroll) {\n    overflow-y: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
